/**
 * WHAT THE AI ROOF BUTTON OPENS, WHICH IS ALMOST NOTHING.
 *
 * Pressing AI roof runs it. This sheet is not in the way of that: it opens for
 * the two situations where there is nothing to press through - a reading in
 * flight, which is where Cancel lives, and a missing sign in, which has to be
 * fixed before anything can happen. Plus whatever the last attempt has to say.
 *
 * It used to explain, in four paragraphs, what a suggestion was, that each one
 * had to be included, that a second press cost another reading, and exactly
 * what a replacement would and would not remove. Every sentence was true when
 * it was written. Then suggestions started arriving lit, the review step went
 * away, the spend got a daily ceiling, and a regeneration learned to spare
 * anything you had touched - and the words outlived all of it. Reported as: I
 * do not know what all these questions are asking me, make it super minimal, I
 * do not want too much text and pop-ups.
 *
 * The rule for anything added here: it earns its place by being something a
 * person has to ACT on. Reassurance is not information.
 */

import { useState } from 'react'
import { useEditor } from '../store/useEditor'

export function SuggestBlock() {
  const photo = useEditor((s) => s.doc.photo)
  const suggest = useEditor((s) => s.suggest)
  const accessCode = useEditor((s) => s.accessCode)
  const setAccessCode = useEditor((s) => s.setAccessCode)
  const cancel = useEditor((s) => s.cancelSuggestions)
  const dismiss = useEditor((s) => s.dismissSuggestMessage)

  const [code, setCode] = useState('')

  const running = suggest.phase === 'uploading' || suggest.phase === 'analyzing'

  if (!accessCode) {
    return (
      <div className="sel-block">
        <h2>Sign in to use the AI</h2>
        <input
          type="text"
          value={code}
          placeholder="Access code"
          autoComplete="off"
          spellCheck={false}
          onChange={(e) => setCode(e.target.value)}
        />
        <button
          className="btn wide primary"
          disabled={!code.trim()}
          onClick={() => {
            setAccessCode(code)
            setCode('')
          }}
        >
          Save
        </button>
      </div>
    )
  }

  if (running) {
    return (
      <div className="sel-block">
        <h2>{suggest.phase === 'uploading' ? 'Sending the photo' : 'Reading the roof'}</h2>
        <button className="btn wide" onClick={cancel}>
          Cancel
        </button>
      </div>
    )
  }

  // Everything below is a thing that went wrong, or a photo that is missing.
  // With neither, this sheet has no reason to be on screen at all.
  return (
    <div className="sel-block">
      {!photo ? (
        <p className="hint">Add a photo first.</p>
      ) : suggest.message ? (
        <p className="hint" role="status">
          {suggest.message}{' '}
          <button className="link-btn" onClick={dismiss}>
            Dismiss
          </button>
        </p>
      ) : (
        <p className="hint">Press AI roof to read this photo.</p>
      )}
    </div>
  )
}
